import { render, staticRenderFns } from "./CheckDayOfWeek.vue?vue&type=template&id=126e2efa&"
import script from "./CheckDayOfWeek.vue?vue&type=script&lang=ts&"
export * from "./CheckDayOfWeek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports